export function isRecaptchaShown(failedLoginAttemptsNumber) {
  const NUMBER_LOGIN_ATTEMPTS_WITHOUT_RECAPTCHA = 4;

  return failedLoginAttemptsNumber >= NUMBER_LOGIN_ATTEMPTS_WITHOUT_RECAPTCHA;
}
